"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var radioGroupTokens = {
  background: {
    color: {
      item: {
        default: _tokens.default.sky.sys.color.background.neutral["1"],
        disabled: _tokens.default.sky.sys.color.background.disabled["1"]
      },
      indicator: {
        active: _tokens.default.sky.sys.color.border.active,
        disabled: _tokens.default.sky.sys.color.border.disabledondisabled
      }
    }
  },
  gap: {
    root: _tokens.default.sky.sys.spacing["400"],
    textContainer: _tokens.default.sky.sys.spacing["100"]
  },
  border: {
    width: {
      item: {
        default: _tokens.default.sky.sys.size.borderwidth.thin,
        selected: _tokens.default.sky.sys.size.borderwidth.thick
      }
    },
    color: {
      item: {
        disabled: _tokens.default.sky.sys.color.border.disabledondisabled,
        default: _tokens.default.sky.sys.color.border.enabled,
        selected: _tokens.default.sky.sys.color.border.active
      }
    }
  },
  size: {
    height: {
      item: '20px',
      indicator: '8px'
    },
    width: {
      item: '20px',
      indicator: '8px'
    }
  },
  shadow: {
    item: {
      focusRing: _tokens.default.sky.sys.elevation.shadow.focusring
    }
  }
};
var _default = exports.default = radioGroupTokens;